import { BCCombobox, findMessage } from '@bimser/components';
import Styles from '../assets/Styles.scss';
import { INavigationBox } from '../entities/IDMGridProps';

export const NavigationBox: React.FC<INavigationBox> = props => (
	<BCCombobox
		showSearch={false}
		size="middle"
		rawOptions={props?.items?.map(item => ({
			label: item.id === '#Root' ? findMessage.get('103713') : item.name,
			value: item.id
		}))}
		onSelectedChange={value => props?.onValueChanged(value)}
		value={props?.value}
		className={Styles.navigationBox}
		variant="filled"
	/>
);
